export const buildQuickstartSteamUrl = (steamUrl: string): string => {
  if (typeof window === 'undefined') {
    return steamUrl;
  }

  try {
    const url = new URL(steamUrl);
    const steamParams = url.searchParams;
    const pageParams = new URLSearchParams(window.location.search);

    const pageUtmSource = pageParams.get('utm_source') ?? undefined;
    const pageUtmMedium = pageParams.get('utm_medium') ?? undefined;

    if (pageUtmSource) {
      const combinedMedium = pageUtmMedium ? `${pageUtmMedium}_${pageUtmSource}` : pageUtmSource;
      steamParams.set('utm_medium', combinedMedium);
    } else if (pageUtmMedium) {
      steamParams.set('utm_medium', pageUtmMedium);
    }

    pageParams.forEach((value, key) => {
      if (!key.startsWith('utm_')) {
        return;
      }
      if (key === 'utm_source' || key === 'utm_medium') {
        return;
      }
      if (value) {
        steamParams.set(key, value);
      }
    });

    url.search = steamParams.toString();
    return url.toString();
  } catch {
    return steamUrl;
  }
};
